import { render } from "./OfferVacuum.vue?vue&type=template&id=328770f5"
import script from "./OfferVacuum.vue?vue&type=script&lang=js"
export * from "./OfferVacuum.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__